var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import CardItem from "../../commons/CardItem/CardItem";
import { Translate as T } from "react-localize-redux";
import { ArrowLeftOutlined } from "@material-ui/icons";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
import { useCheckoutKpayPaymentSelect } from "./state/useCheckoutKpayPaymentSelect";
import { BRANDS_IMGS } from "../../../shared/constants/BrandsImgEnum";
import { CardsEnum } from "../../../shared/constants/CardsEnum";
var useStyles = makeStyles(function () { return ({
    box: {
        marginTop: "10px",
    },
    editButton: {
        display: "flex",
        justifyContent: "flex-end",
    },
}); });
export var CheckoutKpayPaymentSelect = function () {
    var classes = useStyles();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var getLabelKpayPayment = function (kpayPayment) {
        switch (kpayPayment.kind) {
            case "card":
                var brand = kpayPayment.brand
                    ? kpayPayment.brand.toLowerCase()
                    : CardsEnum.visa;
                return {
                    description: kpayPayment.cardHolderName,
                    logo: BRANDS_IMGS[brand],
                    title: "**** " + kpayPayment.lastFourDigits,
                };
            case "transfer":
                return {
                    description: kpayPayment.name,
                    logo: BRANDS_IMGS[CardsEnum.transfer],
                    title: kpayPayment.documentType + " " + kpayPayment.documentNumber,
                };
            case "cash":
                return {
                    description: kpayPayment.name,
                    logo: BRANDS_IMGS[CardsEnum.cash],
                    title: kpayPayment.documentType + " " + kpayPayment.documentNumber,
                };
        }
    };
    var _b = useCheckoutKpayPaymentSelect(), _c = _b.handlers, setIsDelete = _c.setIsDelete, setRedirection = _c.setRedirection, setCheckoutSection = _c.setCheckoutSection, handlerDelete = _c.handlerDelete, handleInitAuth = _c.handleInitAuth, paymentMethodsKpay = _b.paymentMethodsKpay;
    var handleEdit = function () {
        setIsEdit(!isEdit);
        !isEdit && setIsDelete(true);
        !isEdit && handleInitAuth();
    };
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { item: true, xs: 6 },
            React.createElement(Button, { id: "return-button", startIcon: React.createElement(ArrowLeftOutlined, null), onClick: function () { return setCheckoutSection(configCardSections.paymentMethods); } },
                React.createElement(Typography, null,
                    React.createElement(T, { id: "kpayEmail.return" })))),
        React.createElement(Grid, { item: true, xs: 6, className: classes.editButton },
            React.createElement(Button, { onClick: handleEdit },
                React.createElement(Typography, null, isEdit ? React.createElement(T, { id: "kpayEmail.save" }) : React.createElement(T, { id: "kpayEmail.edit" })))),
        React.createElement(Grid, { item: true, xs: 12, className: classes.box }, paymentMethodsKpay.map(function (paymentMethodKpay, index) {
            return (React.createElement(CardItem, __assign({ key: index }, getLabelKpayPayment(paymentMethodKpay), { handlerOnClick: isEdit
                    ? function () { return handlerDelete(paymentMethodKpay.id); }
                    : function () { return setRedirection(paymentMethodKpay); }, isEdit: isEdit, isKpay: true })));
        }))));
};
